export default __webpack_public_path__ + "static/media/pbi2.592f6c13.JPG";